module.exports = __webpack_public_path__ + "static/media/speakers_logos_Veolia.daafcea3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/speakers_logos_Veolia.jpg
// module id = 281
// module chunks = 0